import SpinEndState from "../../core/src/states/SpinEndState";

export default class VendorSpinEndState extends SpinEndState {
};
